import { ColumnType } from '../../../types';
import { ChartSettingsV2MenuItems, } from '../chart-settings-v2-schema.types';
import { createAggregationDropdown, createAxisGridlinesFormatter, createAxisGridlinesVisibilityCheckbox, createAxisHorizontalPositionControl, createAxisIntervalsFormatter, createAxisIntervalsVisibilityCheckbox, createAxisLinesAccordionItem, createAxisNameAccordionItem, createAxisNameFontFormatter, createAxisNameTextInput, createAxisNameVisibilityCheckbox, createAxisValueLabelFontFormatter, createAxisValueLabelMaxCharactersInput, createAxisValueLabelNumberFormatter, createAxisValueLabelVisibilityCheckbox, createAxisVisibilityCheckbox, createBackgroundAccordionItem, createCandlestickColorPicker, createChartBackgroundColorFormatter, createChartColumnNumberFormatter, createChartConditionalFormatter, createChartZoomComponent, createColumnColorPicker, createColumnDataColorsPicker, createColumnNameTextInput, createIntervalsAccordionItem, createMaxDataPointsInput, createPlotAreaBackgroundColorFormatter, createResponsiveLayoutCheckbox, createTimeBucketDropdown, createTooltipBackgroundFormatter, createTooltipContentFormatter, createTooltipFieldLabelFormatter, createTooltipFontFormatter, createTooltipVisibilityCheckbox, createValueLabelAccordionItem, createYAxisNumberRangeInput, } from '../schema-composer-utils/common-elements';
import { shouldHideAxisSettings, shouldHideTooltipSettings, } from '../schema-composer-utils/common-rules';
import { createAccordion, createAccordionItem, createBackgroundImageEditor, createSection, } from '../schema-composer-utils/elements';
const columnSettings = [
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                properties: {
                                    header: '',
                                    isExpanded: true,
                                    noPadding: true,
                                    variant: 'sideNav',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createColumnDataColorsPicker(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createAggregationDropdown(),
                                    createColumnColorPicker(),
                                    createChartConditionalFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Date,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        properties: {
                            spacing: 'ignore',
                        },
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createTimeBucketDropdown(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
];
const tooltipSettings = [
    createSection({
        children: [
            createTooltipVisibilityCheckbox(),
            createTooltipContentFormatter(),
        ],
    }),
    createSection({
        isAdvanced: true,
        children: [
            createTooltipBackgroundFormatter(),
            createTooltipFieldLabelFormatter(),
            createTooltipFontFormatter(),
        ],
        isHiddenCallback: shouldHideTooltipSettings,
    }),
];
const displaySettings = [
    createSection({
        children: [
            createResponsiveLayoutCheckbox(),
            createMaxDataPointsInput(),
            createCandlestickColorPicker(),
            createChartZoomComponent(),
        ],
    }),
    createSection({
        isAdvanced: true,
        children: [
            createAccordion({
                children: [
                    createBackgroundAccordionItem([
                        createChartBackgroundColorFormatter(),
                        createPlotAreaBackgroundColorFormatter(),
                        createBackgroundImageEditor(),
                    ]),
                ],
            }),
        ],
    }),
];
const axisSettings = [
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [createAxisVisibilityCheckbox()],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createAxisNameAccordionItem([
                                createAxisNameVisibilityCheckbox(),
                                createAxisNameTextInput(),
                                createAxisNameFontFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createValueLabelAccordionItem([
                                createAxisValueLabelVisibilityCheckbox(),
                                createAxisValueLabelNumberFormatter(),
                                createAxisValueLabelFontFormatter(),
                                createAxisValueLabelMaxCharactersInput(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAxisLinesAccordionItem([
                                createAxisGridlinesVisibilityCheckbox(),
                                createAxisGridlinesFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createIntervalsAccordionItem([
                                createAxisIntervalsVisibilityCheckbox(),
                                createAxisIntervalsFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAxisVisibilityCheckbox(),
                    createAxisHorizontalPositionControl(),
                    createYAxisNumberRangeInput(),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createAxisNameAccordionItem([
                                createAxisNameVisibilityCheckbox(),
                                createAxisNameTextInput(),
                                createAxisNameFontFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createValueLabelAccordionItem([
                                createAxisValueLabelVisibilityCheckbox(),
                                createAxisValueLabelNumberFormatter(),
                                createAxisValueLabelFontFormatter(),
                                createAxisValueLabelMaxCharactersInput(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAxisLinesAccordionItem([
                                createAxisGridlinesVisibilityCheckbox(),
                                createAxisGridlinesFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createIntervalsAccordionItem([
                                createAxisIntervalsVisibilityCheckbox(),
                                createAxisIntervalsFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Date,
        settings: [
            createSection({
                children: [createAxisVisibilityCheckbox()],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createAxisNameAccordionItem([
                                createAxisNameVisibilityCheckbox(),
                                createAxisNameTextInput(),
                                createAxisNameFontFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createValueLabelAccordionItem([
                                createAxisValueLabelVisibilityCheckbox(),
                                createAxisValueLabelFontFormatter(),
                                createAxisValueLabelMaxCharactersInput(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAxisLinesAccordionItem([
                                createAxisGridlinesVisibilityCheckbox(),
                                createAxisGridlinesFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createIntervalsAccordionItem([
                                createAxisIntervalsVisibilityCheckbox(),
                                createAxisIntervalsFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
        ],
    },
];
export const candlestickChartSettingsSchema = {
    [ChartSettingsV2MenuItems.COLUMN]: columnSettings,
    [ChartSettingsV2MenuItems.AXIS]: axisSettings,
    [ChartSettingsV2MenuItems.DATA_LABEL]: null,
    [ChartSettingsV2MenuItems.TOOLTIP]: tooltipSettings,
    [ChartSettingsV2MenuItems.LEGEND]: null,
    [ChartSettingsV2MenuItems.DISPLAY]: displaySettings,
};
//# sourceMappingURL=candlestick-schema.js.map